module.exports = __webpack_public_path__ + "static/media/Setting.8991e3e0.svg";